@if (estado(); as e) {
    <span class="inline-flex items-center gap-2 whitespace-nowrap">
        <img [src]="e.bandeira" [alt]="e.nome" class="estado-bandeira" />
        <span>{{ e.sigla }} - {{ e.nome }}</span>
    </span>
} @else if (uf()) {
    <span class="whitespace-nowrap">{{ uf() }}</span>
}
